var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_135_3233)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_135_3233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200 0H0V200H200V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8978 16.3267H16.3264V20.4083H44.8978V16.3267Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0611 16.3267H48.9795V20.4083H53.0611V16.3267Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4694 16.3267H65.3062V20.4083H73.4694V16.3267Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7142 16.3267H81.6326V20.4083H85.7142V16.3267Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.286 16.3267H97.9592V20.4083H114.286V16.3267Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.857 16.3267H134.694V20.4083H142.857V16.3267Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.673 16.3267H155.102V20.4083H183.673V16.3267Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.408 20.4082H16.3264V24.4898H20.408V20.4082Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.898 20.4082H40.8164V24.4898H44.898V20.4082Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3061 20.4082H57.1428V24.4898H65.3061V20.4082Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6326 20.4082H69.3877V24.4898H81.6326V20.4082Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8775 20.4082H89.7959V24.4898H93.8775V20.4082Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.041 20.4082H97.9592V24.4898H102.041V20.4082Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.531 20.4082H114.286V24.4898H126.531V20.4082Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.694 20.4082H130.612V24.4898H134.694V20.4082Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.857 20.4082H138.775V24.4898H142.857V20.4082Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.02 20.4082H146.939V24.4898H151.02V20.4082Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.184 20.4082H155.102V24.4898H159.184V20.4082Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.673 20.4082H179.592V24.4898H183.673V20.4082Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.408 24.4897H16.3264V28.5714H20.408V24.4897Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7346 24.4897H24.4897V28.5714H36.7346V24.4897Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.898 24.4897H40.8164V28.5714H44.898V24.4897Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.306 24.4897H48.9795V28.5714H65.306V24.4897Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5511 24.4897H73.4695V28.5714H77.5511V24.4897Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9591 24.4897H93.8774V28.5714H97.9591V24.4897Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.286 24.4897H106.123V28.5714H114.286V24.4897Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.449 24.4897H118.367V28.5714H122.449V24.4897Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.694 24.4897H126.531V28.5714H134.694V24.4897Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.02 24.4897H142.857V28.5714H151.02V24.4897Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.184 24.4897H155.102V28.5714H159.184V24.4897Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.51 24.4897H163.265V28.5714H175.51V24.4897Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.673 24.4897H179.592V28.5714H183.673V24.4897Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.408 28.5713H16.3264V32.6529H20.408V28.5713Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7346 28.5713H24.4897V32.6529H36.7346V28.5713Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.898 28.5713H40.8164V32.6529H44.898V28.5713Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3877 28.5713H57.1428V32.6529H69.3877V28.5713Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.796 28.5713H85.7144V32.6529H89.796V28.5713Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.204 28.5713H106.123V32.6529H110.204V28.5713Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.694 28.5713H126.531V32.6529H134.694V28.5713Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.02 28.5713H138.775V32.6529H151.02V28.5713Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.184 28.5713H155.102V32.6529H159.184V28.5713Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.51 28.5713H163.265V32.6529H175.51V28.5713Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.673 28.5713H179.592V32.6529H183.673V28.5713Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.408 32.6528H16.3264V36.7345H20.408V32.6528Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7346 32.6528H24.4897V36.7345H36.7346V32.6528Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.898 32.6528H40.8164V36.7345H44.898V32.6528Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0611 32.6528H48.9795V36.7345H53.0611V32.6528Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3878 32.6528H65.3062V36.7345H69.3878V32.6528Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6327 32.6528H77.551V36.7345H81.6327V32.6528Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.796 32.6528H85.7144V36.7345H89.796V32.6528Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.041 32.6528H97.9592V36.7345H102.041V32.6528Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.204 32.6528H106.123V36.7345H110.204V32.6528Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.449 32.6528H114.286V36.7345H122.449V32.6528Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.694 32.6528H130.612V36.7345H134.694V32.6528Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.02 32.6528H142.857V36.7345H151.02V32.6528Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.184 32.6528H155.102V36.7345H159.184V32.6528Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.51 32.6528H163.265V36.7345H175.51V32.6528Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.673 32.6528H179.592V36.7345H183.673V32.6528Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.408 36.7349H16.3264V40.8165H20.408V36.7349Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.898 36.7349H40.8164V40.8165H44.898V36.7349Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1429 36.7349H53.0613V40.8165H57.1429V36.7349Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3062 36.7349H61.2246V40.8165H65.3062V36.7349Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4693 36.7349H69.3877V40.8165H73.4693V36.7349Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7143 36.7349H77.551V40.8165H85.7143V36.7349Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9592 36.7349H89.7959V40.8165H97.9592V36.7349Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.367 36.7349H110.204V40.8165H118.367V36.7349Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.531 36.7349H122.449V40.8165H126.531V36.7349Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.857 36.7349H130.612V40.8165H142.857V36.7349Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.184 36.7349H155.102V40.8165H159.184V36.7349Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.673 36.7349H179.592V40.8165H183.673V36.7349Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8978 40.8164H16.3264V44.898H44.8978V40.8164Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0611 40.8164H48.9795V44.898H53.0611V40.8164Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2245 40.8164H57.1428V44.898H61.2245V40.8164Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3878 40.8164H65.3062V44.898H69.3878V40.8164Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5511 40.8164H73.4695V44.898H77.5511V40.8164Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7142 40.8164H81.6326V44.898H85.7142V40.8164Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8775 40.8164H89.7959V44.898H93.8775V40.8164Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.041 40.8164H97.9592V44.898H102.041V40.8164Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.204 40.8164H106.123V44.898H110.204V40.8164Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.367 40.8164H114.286V44.898H118.367V40.8164Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.531 40.8164H122.449V44.898H126.531V40.8164Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.694 40.8164H130.612V44.898H134.694V40.8164Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.857 40.8164H138.775V44.898H142.857V40.8164Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.02 40.8164H146.939V44.898H151.02V40.8164Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.673 40.8164H155.102V44.898H183.673V40.8164Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0611 44.8979H48.9795V48.9796H53.0611V44.8979Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7142 44.8979H81.6326V48.9796H85.7142V44.8979Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.041 44.8979H97.9592V48.9796H102.041V44.8979Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.286 44.8979H106.123V48.9796H114.286V44.8979Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.694 44.8979H122.449V48.9796H134.694V44.8979Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.02 44.8979H142.857V48.9796H151.02V44.8979Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8979 48.9795H36.7346V53.0611H44.8979V48.9795Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1429 48.9795H53.0613V53.0611H57.1429V48.9795Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3062 48.9795H61.2246V53.0611H65.3062V48.9795Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.551 48.9795H69.3877V53.0611H77.551V48.9795Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.041 48.9795H85.7144V53.0611H102.041V48.9795Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.204 48.9795H106.123V53.0611H110.204V48.9795Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.775 48.9795H134.694V53.0611H138.775V48.9795Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.02 48.9795H142.857V53.0611H151.02V48.9795Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.184 48.9795H155.102V53.0611H159.184V48.9795Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.347 48.9795H163.265V53.0611H167.347V48.9795Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.51 48.9795H171.428V53.0611H175.51V48.9795Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.673 48.9795H179.592V53.0611H183.673V48.9795Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5714 53.061H24.4897V57.1427H28.5714V53.061Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8163 53.061H32.6531V57.1427H40.8163V53.061Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0611 53.061H48.9795V57.1427H53.0611V53.061Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3062 53.061H61.2246V57.1427H65.3062V53.061Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4693 53.061H69.3877V57.1427H73.4693V53.061Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6327 53.061H77.551V57.1427H81.6327V53.061Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.796 53.061H85.7144V57.1427H89.796V53.061Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9591 53.061H93.8774V57.1427H97.9591V53.061Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.939 53.061H114.286V57.1427H146.939V53.061Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.102 53.061H151.021V57.1427H155.102V53.061Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.347 53.061H163.265V57.1427H167.347V53.061Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.592 53.061H175.51V57.1427H179.592V53.061Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.898 57.1431H32.6531V61.2247H44.898V57.1431Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2245 57.1431H57.1428V61.2247H61.2245V57.1431Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.551 57.1431H69.3877V61.2247H77.551V57.1431Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.041 57.1431H89.7959V61.2247H102.041V57.1431Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.612 57.1431H114.286V61.2247H130.612V57.1431Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.857 57.1431H134.694V61.2247H142.857V57.1431Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.102 57.1431H146.939V61.2247H155.102V57.1431Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4898 61.2246H20.4082V65.3062H24.4898V61.2246Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8164 61.2246H28.5715V65.3062H40.8164V61.2246Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0612 61.2246H44.8979V65.3062H53.0612V61.2246Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2245 61.2246H57.1428V65.3062H61.2245V61.2246Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3878 61.2246H65.3062V65.3062H69.3878V61.2246Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.367 61.2246H85.7144V65.3062H118.367V61.2246Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.531 61.2246H122.449V65.3062H126.531V61.2246Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.694 61.2246H130.612V65.3062H134.694V61.2246Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.102 61.2246H142.857V65.3062H155.102V61.2246Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.429 61.2246H163.265V65.3062H171.429V61.2246Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.673 61.2246H179.592V65.3062H183.673V61.2246Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7346 65.3062H24.4897V69.3878H36.7346V65.3062Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9797 65.3062H40.8164V69.3878H48.9797V65.3062Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3878 65.3062H53.0613V69.3878H69.3878V65.3062Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6327 65.3062H73.4695V69.3878H81.6327V65.3062Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8775 65.3062H89.7959V69.3878H93.8775V65.3062Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.449 65.3062H110.204V69.3878H122.449V65.3062Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.857 65.3062H138.775V69.3878H142.857V65.3062Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.265 65.3062H146.939V69.3878H163.265V65.3062Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.674 65.3062H175.51V69.3878H183.674V65.3062Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.408 69.3877H16.3264V73.4693H20.408V69.3877Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8163 69.3877H36.7346V73.4693H40.8163V69.3877Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0611 69.3877H48.9795V73.4693H53.0611V69.3877Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5511 69.3877H73.4695V73.4693H77.5511V69.3877Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.041 69.3877H93.8774V73.4693H102.041V69.3877Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.449 69.3877H114.286V73.4693H122.449V69.3877Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.857 69.3877H138.775V73.4693H142.857V69.3877Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.102 69.3877H146.939V73.4693H155.102V69.3877Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.51 69.3877H163.265V73.4693H175.51V69.3877Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.673 69.3877H179.592V73.4693H183.673V69.3877Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6531 73.4692H20.4082V77.5509H32.6531V73.4692Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8979 73.4692H36.7346V77.5509H44.8979V73.4692Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0611 73.4692H48.9795V77.5509H53.0611V73.4692Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3061 73.4692H57.1428V77.5509H65.3061V73.4692Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.551 73.4692H69.3877V77.5509H77.551V73.4692Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.123 73.4692H85.7144V77.5509H106.123V73.4692Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.939 73.4692H118.367V77.5509H146.939V73.4692Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.102 73.4692H151.021V77.5509H155.102V73.4692Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.429 73.4692H163.265V77.5509H171.429V73.4692Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4897 77.5508H16.3264V81.6324H24.4897V77.5508Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7348 77.5508H28.5715V81.6324H36.7348V77.5508Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9796 77.5508H44.8979V81.6324H48.9796V77.5508Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2245 77.5508H57.1428V81.6324H61.2245V77.5508Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.796 77.5508H73.4695V81.6324H89.796V77.5508Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9591 77.5508H93.8774V81.6324H97.9591V77.5508Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.449 77.5508H110.204V81.6324H122.449V77.5508Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.694 77.5508H130.612V81.6324H134.694V77.5508Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.939 77.5508H142.857V81.6324H146.939V77.5508Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.102 77.5508H151.021V81.6324H155.102V77.5508Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.592 77.5508H159.184V81.6324H179.592V77.5508Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6532 81.6328H28.5715V85.7144H32.6532V81.6328Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.898 81.6328H40.8164V85.7144H44.898V81.6328Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1428 81.6328H48.9795V85.7144H57.1428V81.6328Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4693 81.6328H69.3877V85.7144H73.4693V81.6328Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6327 81.6328H77.551V85.7144H81.6327V81.6328Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8775 81.6328H89.7959V85.7144H93.8775V81.6328Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.204 81.6328H102.041V85.7144H110.204V81.6328Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.776 81.6328H122.449V85.7144H138.776V81.6328Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.102 81.6328H142.857V85.7144H155.102V81.6328Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.265 81.6328H159.184V85.7144H163.265V81.6328Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.51 81.6328H171.428V85.7144H175.51V81.6328Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.408 85.7144H16.3264V89.796H20.408V85.7144Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.653 85.7144H24.4897V89.796H32.653V85.7144Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0611 85.7144H48.9795V89.796H53.0611V85.7144Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3877 85.7144H57.1428V89.796H69.3877V85.7144Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.041 85.7144H97.9592V89.796H102.041V85.7144Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.367 85.7144H114.286V89.796H118.367V85.7144Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.612 85.7144H122.449V89.796H130.612V85.7144Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.857 85.7144H134.694V89.796H142.857V85.7144Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.347 85.7144H146.939V89.796H167.347V85.7144Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.51 85.7144H171.428V89.796H175.51V85.7144Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.673 85.7144H179.592V89.796H183.673V85.7144Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7346 89.7959H24.4897V93.8775H36.7346V89.7959Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.898 89.7959H40.8164V93.8775H44.898V89.7959Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0611 89.7959H48.9795V93.8775H53.0611V89.7959Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5511 89.7959H65.3062V93.8775H77.5511V89.7959Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.041 89.7959H97.9592V93.8775H102.041V89.7959Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.286 89.7959H106.123V93.8775H114.286V89.7959Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.612 89.7959H122.449V93.8775H130.612V89.7959Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.02 89.7959H142.857V93.8775H151.02V89.7959Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.428 89.7959H159.184V93.8775H171.428V89.7959Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.673 89.7959H179.592V93.8775H183.673V89.7959Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4898 93.8774H20.4082V97.9591H24.4898V93.8774Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6532 93.8774H28.5715V97.9591H32.6532V93.8774Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8163 93.8774H36.7346V97.9591H40.8163V93.8774Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0611 93.8774H48.9795V97.9591H53.0611V93.8774Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3062 93.8774H61.2246V97.9591H65.3062V93.8774Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4693 93.8774H69.3877V97.9591H73.4693V93.8774Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7143 93.8774H77.551V97.9591H85.7143V93.8774Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.041 93.8774H89.7959V97.9591H102.041V93.8774Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.367 93.8774H106.123V97.9591H118.367V93.8774Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.939 93.8774H130.612V97.9591H146.939V93.8774Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.184 93.8774H155.102V97.9591H159.184V93.8774Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.429 93.8774H163.265V97.9591H171.429V93.8774Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.674 93.8774H175.51V97.9591H183.674V93.8774Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5713 97.959H16.3264V102.041H28.5713V97.959Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8979 97.959H36.7346V102.041H44.8979V97.959Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2245 97.959H53.0613V102.041H61.2245V97.959Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6327 97.959H77.551V102.041H81.6327V97.959Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8775 97.959H89.7959V102.041H93.8775V97.959Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.122 97.959H102.041V102.041H106.122V97.959Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.367 97.959H110.204V102.041H118.367V97.959Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.612 97.959H126.531V102.041H130.612V97.959Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.592 97.959H163.265V102.041H179.592V97.959Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.408 102.041H16.3264V106.123H20.408V102.041Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.653 102.041H24.4897V106.123H32.653V102.041Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1429 102.041H53.0613V106.123H57.1429V102.041Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6328 102.041H61.2246V106.123H81.6328V102.041Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9593 102.041H85.7144V106.123H97.9593V102.041Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.204 102.041H106.123V106.123H110.204V102.041Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.612 102.041H126.531V106.123H130.612V102.041Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.939 102.041H134.694V106.123H146.939V102.041Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.265 102.041H159.184V106.123H163.265V102.041Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.51 102.041H167.347V106.123H175.51V102.041Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4898 106.123H20.4082V110.204H24.4898V106.123Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.898 106.123H32.6531V110.204H44.898V106.123Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0611 106.123H48.9795V110.204H53.0611V106.123Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2245 106.123H57.1428V110.204H61.2245V106.123Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3878 106.123H65.3062V110.204H69.3878V106.123Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6327 106.123H77.551V110.204H81.6327V106.123Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9593 106.123H85.7144V110.204H97.9593V106.123Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.204 106.123H106.123V110.204H110.204V106.123Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.694 106.123H122.449V110.204H134.694V106.123Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.857 106.123H138.775V110.204H142.857V106.123Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.02 106.123H146.939V110.204H151.02V106.123Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.184 106.123H155.102V110.204H159.184V106.123Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.429 106.123H167.347V110.204H171.429V106.123Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6531 110.204H20.4082V114.286H32.6531V110.204Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1429 110.204H53.0613V114.286H57.1429V110.204Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3062 110.204H61.2246V114.286H65.3062V110.204Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5511 110.204H73.4695V114.286H77.5511V110.204Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8776 110.204H85.7144V114.286H93.8776V110.204Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.286 110.204H102.041V114.286H114.286V110.204Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.449 110.204H118.367V114.286H122.449V110.204Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.694 110.204H126.531V114.286H134.694V110.204Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.857 110.204H138.775V114.286H142.857V110.204Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.265 110.204H151.021V114.286H163.265V110.204Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.429 110.204H167.347V114.286H171.429V110.204Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.674 110.204H175.51V114.286H183.674V110.204Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.898 114.286H20.4082V118.367H44.898V114.286Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1429 114.286H53.0613V118.367H57.1429V114.286Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4694 114.286H65.3062V118.367H73.4694V114.286Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6327 114.286H77.551V118.367H81.6327V114.286Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8775 114.286H89.7959V118.367H93.8775V114.286Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.041 114.286H97.9592V118.367H102.041V114.286Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.449 114.286H106.123V118.367H122.449V114.286Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.694 114.286H126.531V118.367H134.694V114.286Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.02 114.286H146.939V118.367H151.02V114.286Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.184 114.286H155.102V118.367H159.184V114.286Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.429 114.286H167.347V118.367H171.429V114.286Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.408 118.367H16.3264V122.449H20.408V118.367Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7348 118.367H28.5715V122.449H36.7348V118.367Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9796 118.367H44.8979V122.449H48.9796V118.367Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3061 118.367H57.1428V122.449H65.3061V118.367Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5511 118.367H73.4695V122.449H77.5511V118.367Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.796 118.367H85.7144V122.449H89.796V118.367Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.122 118.367H102.041V122.449H106.122V118.367Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.367 118.367H110.204V122.449H118.367V118.367Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.939 118.367H122.449V122.449H146.939V118.367Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.184 118.367H151.021V122.449H159.184V118.367Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.429 118.367H163.265V122.449H171.429V118.367Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.674 118.367H175.51V122.449H183.674V118.367Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.408 122.449H16.3264V126.531H20.408V122.449Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5714 122.449H24.4897V126.531H28.5714V122.449Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9797 122.449H40.8164V126.531H48.9797V122.449Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2245 122.449H53.0613V126.531H61.2245V122.449Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7143 122.449H77.551V126.531H85.7143V122.449Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9591 122.449H93.8774V126.531H97.9591V122.449Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.204 122.449H102.041V126.531H110.204V122.449Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.612 122.449H122.449V126.531H130.612V122.449Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.775 122.449H134.694V126.531H138.775V122.449Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.02 122.449H146.939V126.531H151.02V122.449Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.184 122.449H155.102V126.531H159.184V122.449Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.347 122.449H163.265V126.531H167.347V122.449Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5713 126.531H16.3264V130.612H28.5713V126.531Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1429 126.531H53.0613V130.612H57.1429V126.531Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3879 126.531H61.2246V130.612H69.3879V126.531Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6327 126.531H77.551V130.612H81.6327V126.531Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.796 126.531H85.7144V130.612H89.796V126.531Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.204 126.531H93.8774V130.612H110.204V126.531Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.531 126.531H122.449V130.612H126.531V126.531Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.939 126.531H142.857V130.612H146.939V126.531Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.51 126.531H159.184V130.612H175.51V126.531Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.673 126.531H179.592V130.612H183.673V126.531Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5714 130.612H24.4897V134.694H28.5714V130.612Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9796 130.612H32.6531V134.694H48.9796V130.612Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2245 130.612H57.1428V134.694H61.2245V130.612Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6327 130.612H65.3062V134.694H81.6327V130.612Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.796 130.612H85.7144V134.694H89.796V130.612Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9591 130.612H93.8774V134.694H97.9591V130.612Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.122 130.612H102.041V134.694H106.122V130.612Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.367 130.612H110.204V134.694H118.367V130.612Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.531 130.612H122.449V134.694H126.531V130.612Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.775 130.612H134.694V134.694H138.775V130.612Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.02 130.612H142.857V134.694H151.02V130.612Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.265 130.612H155.102V134.694H163.265V130.612Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.51 130.612H167.347V134.694H175.51V130.612Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.408 134.694H16.3264V138.775H20.408V134.694Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5714 134.694H24.4897V138.775H28.5714V134.694Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7347 134.694H32.6531V138.775H36.7347V134.694Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0612 134.694H44.8979V138.775H53.0612V134.694Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3062 134.694H61.2246V138.775H65.3062V134.694Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7143 134.694H77.551V138.775H85.7143V134.694Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8775 134.694H89.7959V138.775H93.8775V134.694Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.122 134.694H102.041V138.775H106.122V134.694Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.531 134.694H118.367V138.775H126.531V134.694Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.857 134.694H130.612V138.775H142.857V134.694Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.347 134.694H159.184V138.775H167.347V134.694Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.674 134.694H175.51V138.775H183.674V134.694Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4897 138.775H16.3264V142.857H24.4897V138.775Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6532 138.775H28.5715V142.857H32.6532V138.775Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9797 138.775H40.8164V142.857H48.9797V138.775Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2245 138.775H53.0613V142.857H61.2245V138.775Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5511 138.775H65.3062V142.857H77.5511V138.775Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7142 138.775H81.6326V142.857H85.7142V138.775Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.449 138.775H102.041V142.857H122.449V138.775Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.694 138.775H130.612V142.857H134.694V138.775Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.939 138.775H142.857V142.857H146.939V138.775Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.102 138.775H151.021V142.857H155.102V138.775Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.265 138.775H159.184V142.857H163.265V138.775Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.51 138.775H171.428V142.857H175.51V138.775Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.673 138.775H179.592V142.857H183.673V138.775Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.408 142.857H16.3264V146.939H20.408V142.857Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5714 142.857H24.4897V146.939H28.5714V142.857Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8163 142.857H36.7346V146.939H40.8163V142.857Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3062 142.857H53.0613V146.939H65.3062V142.857Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7958 142.857H81.6326V146.939H89.7958V142.857Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9591 142.857H93.8774V146.939H97.9591V142.857Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.204 142.857H102.041V146.939H110.204V142.857Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.449 142.857H114.286V146.939H122.449V142.857Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.694 142.857H126.531V146.939H134.694V142.857Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.184 142.857H155.102V146.939H159.184V142.857Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.429 142.857H163.265V146.939H171.429V142.857Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.592 142.857H175.51V146.939H179.592V142.857Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.408 146.939H16.3264V151.021H20.408V146.939Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7348 146.939H28.5715V151.021H36.7348V146.939Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1429 146.939H40.8164V151.021H57.1429V146.939Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3062 146.939H61.2246V151.021H65.3062V146.939Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6327 146.939H77.551V151.021H81.6327V146.939Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.796 146.939H85.7144V151.021H89.796V146.939Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.122 146.939H102.041V151.021H106.122V146.939Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.286 146.939H110.204V151.021H114.286V146.939Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.531 146.939H118.367V151.021H126.531V146.939Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.775 146.939H134.694V151.021H138.775V146.939Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.51 146.939H146.939V151.021H175.51V146.939Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.673 146.939H179.592V151.021H183.673V146.939Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1428 151.021H48.9795V155.102H57.1428V151.021Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4693 151.021H69.3877V155.102H73.4693V151.021Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7143 151.021H77.551V155.102H85.7143V151.021Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.286 151.021H89.7959V155.102H114.286V151.021Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.612 151.021H122.449V155.102H130.612V151.021Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.02 151.021H138.775V155.102H151.02V151.021Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.592 151.021H163.265V155.102H179.592V151.021Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8978 155.102H16.3264V159.184H44.8978V155.102Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3877 155.102H57.1428V159.184H69.3877V155.102Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6327 155.102H73.4695V159.184H81.6327V155.102Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.041 155.102H93.8774V159.184H102.041V155.102Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.367 155.102H114.286V159.184H118.367V155.102Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.612 155.102H126.531V159.184H130.612V155.102Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.02 155.102H138.775V159.184H151.02V155.102Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.184 155.102H155.102V159.184H159.184V155.102Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.51 155.102H163.265V159.184H175.51V155.102Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.408 159.184H16.3264V163.265H20.408V159.184Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.898 159.184H40.8164V163.265H44.898V159.184Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0611 159.184H48.9795V163.265H53.0611V159.184Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2245 159.184H57.1428V163.265H61.2245V159.184Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4694 159.184H65.3062V163.265H73.4694V159.184Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6327 159.184H77.551V163.265H81.6327V159.184Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.796 159.184H85.7144V163.265H89.796V159.184Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.367 159.184H93.8774V163.265H118.367V159.184Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.694 159.184H130.612V163.265H134.694V159.184Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.02 159.184H142.857V163.265H151.02V159.184Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.347 159.184H163.265V163.265H167.347V159.184Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.673 159.184H179.592V163.265H183.673V159.184Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.408 163.265H16.3264V167.347H20.408V163.265Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7346 163.265H24.4897V167.347H36.7346V163.265Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.898 163.265H40.8164V167.347H44.898V163.265Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3878 163.265H65.3062V167.347H69.3878V163.265Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5511 163.265H73.4695V167.347H77.5511V163.265Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9591 163.265H81.6326V167.347H97.9591V163.265Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.122 163.265H102.041V167.347H106.122V163.265Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.612 163.265H110.204V167.347H130.612V163.265Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.347 163.265H134.694V167.347H167.347V163.265Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.408 167.347H16.3264V171.429H20.408V167.347Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7346 167.347H24.4897V171.429H36.7346V167.347Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.898 167.347H40.8164V171.429H44.898V167.347Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1429 167.347H53.0613V171.429H57.1429V167.347Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3062 167.347H61.2246V171.429H65.3062V167.347Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7142 167.347H81.6326V171.429H85.7142V167.347Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8775 167.347H89.7959V171.429H93.8775V167.347Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.122 167.347H102.041V171.429H106.122V167.347Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.367 167.347H110.204V171.429H118.367V167.347Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.612 167.347H122.449V171.429H130.612V167.347Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.939 167.347H142.857V171.429H146.939V167.347Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.265 167.347H159.184V171.429H163.265V167.347Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.429 167.347H167.347V171.429H171.429V167.347Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.673 167.347H179.592V171.429H183.673V167.347Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.408 171.429H16.3264V175.51H20.408V171.429Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7346 171.429H24.4897V175.51H36.7346V171.429Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.898 171.429H40.8164V175.51H44.898V171.429Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3062 171.429H53.0613V175.51H65.3062V171.429Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7142 171.429H69.3877V175.51H85.7142V171.429Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.041 171.429H97.9592V175.51H102.041V171.429Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.367 171.429H114.286V175.51H118.367V171.429Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.612 171.429H126.531V175.51H130.612V171.429Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.429 171.429H151.021V175.51H171.429V171.429Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.592 171.429H175.51V175.51H179.592V171.429Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.408 175.51H16.3264V179.592H20.408V175.51Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.898 175.51H40.8164V179.592H44.898V175.51Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3061 175.51H57.1428V179.592H65.3061V175.51Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4693 175.51H69.3877V179.592H73.4693V175.51Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.449 175.51H85.7144V179.592H122.449V175.51Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.694 175.51H126.531V179.592H134.694V175.51Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.102 175.51H151.021V179.592H155.102V175.51Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.347 175.51H163.265V179.592H167.347V175.51Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.51 175.51H171.428V179.592H175.51V175.51Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.673 175.51H179.592V179.592H183.673V175.51Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8978 179.592H16.3264V183.673H44.8978V179.592Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2245 179.592H53.0613V183.673H61.2245V179.592Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6327 179.592H65.3062V183.673H81.6327V179.592Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.796 179.592H85.7144V183.673H89.796V179.592Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9591 179.592H93.8774V183.673H97.9591V179.592Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.449 179.592H114.286V183.673H122.449V179.592Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.775 179.592H134.694V183.673H138.775V179.592Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.939 179.592H142.857V183.673H146.939V179.592Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.102 179.592H151.021V183.673H155.102V179.592Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.347 179.592H159.184V183.673H167.347V179.592Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.408 16.3267H16.3264V44.8981H20.408V16.3267Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.408 69.3877H16.3264V73.4693H20.408V69.3877Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.408 77.5508H16.3264V81.6324H20.408V77.5508Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.408 85.7144H16.3264V89.796H20.408V85.7144Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.408 97.959H16.3264V106.122H20.408V97.959Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.408 118.367H16.3264V130.612H20.408V118.367Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.408 134.694H16.3264V151.02H20.408V134.694Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.408 155.102H16.3264V183.673H20.408V155.102Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4898 16.3267H20.4082V20.4083H24.4898V16.3267Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4898 40.8164H20.4082V44.898H24.4898V40.8164Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4898 61.2246H20.4082V65.3062H24.4898V61.2246Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4898 73.4692H20.4082V81.6325H24.4898V73.4692Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4898 93.8774H20.4082V102.041H24.4898V93.8774Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4898 106.123H20.4082V118.367H24.4898V106.123Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4898 126.531H20.4082V130.612H24.4898V126.531Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4898 138.775H20.4082V142.857H24.4898V138.775Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4898 155.102H20.4082V159.184H24.4898V155.102Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4898 179.592H20.4082V183.673H24.4898V179.592Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5714 16.3267H24.4897V20.4083H28.5714V16.3267Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5714 24.4897H24.4897V36.7346H28.5714V24.4897Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5714 40.8164H24.4897V44.898H28.5714V40.8164Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5714 53.061H24.4897V57.1427H28.5714V53.061Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5714 65.3062H24.4897V69.3878H28.5714V65.3062Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5714 73.4692H24.4897V77.5509H28.5714V73.4692Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5714 85.7144H24.4897V93.8776H28.5714V85.7144Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5714 97.959H24.4897V106.122H28.5714V97.959Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5714 110.204H24.4897V118.367H28.5714V110.204Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5714 122.449H24.4897V138.776H28.5714V122.449Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5714 142.857H24.4897V146.939H28.5714V142.857Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5714 155.102H24.4897V159.184H28.5714V155.102Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5714 163.265H24.4897V175.51H28.5714V163.265Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5714 179.592H24.4897V183.673H28.5714V179.592Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6532 16.3267H28.5715V20.4083H32.6532V16.3267Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6532 24.4897H28.5715V36.7346H32.6532V24.4897Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6532 40.8164H28.5715V44.898H32.6532V40.8164Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6532 61.2246H28.5715V69.3879H32.6532V61.2246Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6532 73.4692H28.5715V97.959H32.6532V73.4692Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6532 102.041H28.5715V106.123H32.6532V102.041Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6532 110.204H28.5715V122.449H32.6532V110.204Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6532 138.775H28.5715V142.857H32.6532V138.775Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6532 146.939H28.5715V151.021H32.6532V146.939Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6532 155.102H28.5715V159.184H32.6532V155.102Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6532 163.265H28.5715V175.51H32.6532V163.265Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6532 179.592H28.5715V183.673H32.6532V179.592Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7347 16.3267H32.6531V20.4083H36.7347V16.3267Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7347 24.4897H32.6531V36.7346H36.7347V24.4897Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7347 40.8164H32.6531V44.898H36.7347V40.8164Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7347 53.061H32.6531V69.3876H36.7347V53.061Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7347 77.5508H32.6531V81.6324H36.7347V77.5508Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7347 89.7959H32.6531V93.8775H36.7347V89.7959Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7347 106.123H32.6531V110.204H36.7347V106.123Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7347 114.286H32.6531V122.449H36.7347V114.286Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7347 130.612H32.6531V138.776H36.7347V130.612Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7347 146.939H32.6531V151.021H36.7347V146.939Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7347 155.102H32.6531V159.184H36.7347V155.102Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7347 163.265H32.6531V175.51H36.7347V163.265Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7347 179.592H32.6531V183.673H36.7347V179.592Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8163 16.3267H36.7346V20.4083H40.8163V16.3267Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8163 40.8164H36.7346V44.898H40.8163V40.8164Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8163 48.9795H36.7346V65.306H40.8163V48.9795Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8163 69.3877H36.7346V77.551H40.8163V69.3877Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8163 93.8774H36.7346V102.041H40.8163V93.8774Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8163 106.123H36.7346V110.204H40.8163V106.123Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8163 114.286H36.7346V118.367H40.8163V114.286Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8163 130.612H36.7346V134.694H40.8163V130.612Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8163 142.857H36.7346V146.939H40.8163V142.857Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8163 155.102H36.7346V159.184H40.8163V155.102Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8163 179.592H36.7346V183.673H40.8163V179.592Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.898 16.3267H40.8164V44.8981H44.898V16.3267Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.898 48.9795H40.8164V53.0611H44.898V48.9795Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.898 57.1431H40.8164V61.2247H44.898V57.1431Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.898 65.3062H40.8164V69.3878H44.898V65.3062Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.898 73.4692H40.8164V77.5509H44.898V73.4692Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.898 81.6328H40.8164V85.7144H44.898V81.6328Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.898 89.7959H40.8164V93.8775H44.898V89.7959Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.898 97.959H40.8164V102.041H44.898V97.959Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.898 106.123H40.8164V110.204H44.898V106.123Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.898 114.286H40.8164V118.367H44.898V114.286Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.898 122.449H40.8164V126.531H44.898V122.449Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.898 130.612H40.8164V134.694H44.898V130.612Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.898 138.775H40.8164V142.857H44.898V138.775Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.898 146.939H40.8164V151.021H44.898V146.939Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.898 155.102H40.8164V183.673H44.898V155.102Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9796 61.2246H44.8979V69.3879H48.9796V61.2246Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9796 77.5508H44.8979V81.6324H48.9796V77.5508Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9796 118.367H44.8979V126.53H48.9796V118.367Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9796 130.612H44.8979V142.857H48.9796V130.612Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9796 146.939H44.8979V151.021H48.9796V146.939Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0611 16.3267H48.9795V20.4083H53.0611V16.3267Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0611 24.4897H48.9795V28.5714H53.0611V24.4897Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0611 32.6528H48.9795V36.7345H53.0611V32.6528Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0611 40.8164H48.9795V48.9797H53.0611V40.8164Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0611 53.061H48.9795V57.1427H53.0611V53.061Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0611 61.2246H48.9795V65.3062H53.0611V61.2246Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0611 69.3877H48.9795V77.551H53.0611V69.3877Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0611 81.6328H48.9795V97.9593H53.0611V81.6328Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0611 106.123H48.9795V110.204H53.0611V106.123Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0611 134.694H48.9795V138.775H53.0611V134.694Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0611 146.939H48.9795V155.102H53.0611V146.939Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0611 159.184H48.9795V163.265H53.0611V159.184Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1429 24.4897H53.0613V28.5714H57.1429V24.4897Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1429 36.7349H53.0613V40.8165H57.1429V36.7349Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1429 48.9795H53.0613V53.0611H57.1429V48.9795Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1429 65.3062H53.0613V69.3878H57.1429V65.3062Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1429 81.6328H53.0613V85.7144H57.1429V81.6328Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1429 97.959H53.0613V106.122H57.1429V97.959Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1429 110.204H53.0613V118.367H57.1429V110.204Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1429 122.449H53.0613V130.612H57.1429V122.449Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1429 138.775H53.0613V155.102H57.1429V138.775Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1429 167.347H53.0613V175.51H57.1429V167.347Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1429 179.592H53.0613V183.673H57.1429V179.592Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2245 20.4082H57.1428V32.6531H61.2245V20.4082Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2245 40.8164H57.1428V44.898H61.2245V40.8164Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2245 57.1431H57.1428V69.388H61.2245V57.1431Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2245 73.4692H57.1428V81.6325H61.2245V73.4692Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2245 85.7144H57.1428V89.796H61.2245V85.7144Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2245 97.959H57.1428V102.041H61.2245V97.959Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2245 106.123H57.1428V110.204H61.2245V106.123Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2245 118.367H57.1428V126.53H61.2245V118.367Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2245 130.612H57.1428V134.694H61.2245V130.612Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2245 138.775H57.1428V146.939H61.2245V138.775Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2245 155.102H57.1428V163.265H61.2245V155.102Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2245 171.429H57.1428V183.674H61.2245V171.429Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3062 20.4082H61.2246V32.6531H65.3062V20.4082Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3062 36.7349H61.2246V40.8165H65.3062V36.7349Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3062 48.9795H61.2246V57.1428H65.3062V48.9795Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3062 65.3062H61.2246V69.3878H65.3062V65.3062Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3062 73.4692H61.2246V77.5509H65.3062V73.4692Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3062 85.7144H61.2246V89.796H65.3062V85.7144Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3062 93.8774H61.2246V97.9591H65.3062V93.8774Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3062 102.041H61.2246V106.123H65.3062V102.041Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3062 110.204H61.2246V114.286H65.3062V110.204Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3062 118.367H61.2246V122.449H65.3062V118.367Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3062 126.531H61.2246V130.612H65.3062V126.531Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3062 134.694H61.2246V138.775H65.3062V134.694Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3062 142.857H61.2246V151.02H65.3062V142.857Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3062 155.102H61.2246V159.184H65.3062V155.102Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3062 167.347H61.2246V179.592H65.3062V167.347Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3878 16.3267H65.3062V20.4083H69.3878V16.3267Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3878 28.5713H65.3062V36.7346H69.3878V28.5713Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3878 40.8164H65.3062V44.898H69.3878V40.8164Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3878 61.2246H65.3062V69.3879H69.3878V61.2246Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3878 85.7144H65.3062V93.8776H69.3878V85.7144Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3878 102.041H65.3062V110.204H69.3878V102.041Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3878 114.286H65.3062V118.367H69.3878V114.286Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3878 126.531H65.3062V134.694H69.3878V126.531Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3878 138.775H65.3062V142.857H69.3878V138.775Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3878 155.102H65.3062V167.347H69.3878V155.102Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3878 179.592H65.3062V183.673H69.3878V179.592Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4693 16.3267H69.3877V24.4899H73.4693V16.3267Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4693 36.7349H69.3877V40.8165H73.4693V36.7349Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4693 48.9795H69.3877V61.2244H73.4693V48.9795Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4693 73.4692H69.3877V77.5509H73.4693V73.4692Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4693 81.6328H69.3877V85.7144H73.4693V81.6328Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4693 89.7959H69.3877V97.9592H73.4693V89.7959Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4693 102.041H69.3877V106.123H73.4693V102.041Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4693 114.286H69.3877V118.367H73.4693V114.286Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4693 130.612H69.3877V134.694H73.4693V130.612Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4693 138.775H69.3877V142.857H73.4693V138.775Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4693 151.021H69.3877V155.102H73.4693V151.021Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4693 159.184H69.3877V163.265H73.4693V159.184Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4693 171.429H69.3877V183.674H73.4693V171.429Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5511 20.4082H73.4695V28.5715H77.5511V20.4082Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5511 40.8164H73.4695V44.898H77.5511V40.8164Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5511 48.9795H73.4695V53.0611H77.5511V48.9795Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5511 57.1431H73.4695V61.2247H77.5511V57.1431Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5511 65.3062H73.4695V81.6327H77.5511V65.3062Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5511 89.7959H73.4695V93.8775H77.5511V89.7959Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5511 102.041H73.4695V106.123H77.5511V102.041Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5511 110.204H73.4695V114.286H77.5511V110.204Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5511 118.367H73.4695V122.449H77.5511V118.367Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5511 130.612H73.4695V134.694H77.5511V130.612Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5511 138.775H73.4695V142.857H77.5511V138.775Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5511 155.102H73.4695V159.184H77.5511V155.102Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5511 163.265H73.4695V167.347H77.5511V163.265Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5511 171.429H73.4695V175.51H77.5511V171.429Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5511 179.592H73.4695V183.673H77.5511V179.592Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6327 20.4082H77.551V24.4898H81.6327V20.4082Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6327 32.6528H77.551V40.8161H81.6327V32.6528Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6327 53.061H77.551V57.1427H81.6327V53.061Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6327 65.3062H77.551V69.3878H81.6327V65.3062Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6327 77.5508H77.551V85.714H81.6327V77.5508Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6327 93.8774H77.551V110.204H81.6327V93.8774Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6327 114.286H77.551V118.367H81.6327V114.286Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6327 122.449H77.551V138.776H81.6327V122.449Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6327 146.939H77.551V163.265H81.6327V146.939Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6327 171.429H77.551V175.51H81.6327V171.429Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6327 179.592H77.551V183.673H81.6327V179.592Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7142 16.3267H81.6326V20.4083H85.7142V16.3267Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7142 36.7349H81.6326V48.9798H85.7142V36.7349Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7142 77.5508H81.6326V81.6324H85.7142V77.5508Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7142 93.8774H81.6326V97.9591H85.7142V93.8774Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7142 122.449H81.6326V126.531H85.7142V122.449Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7142 134.694H81.6326V146.939H85.7142V134.694Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7142 151.021H81.6326V155.102H85.7142V151.021Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7142 163.265H81.6326V175.51H85.7142V163.265Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.796 28.5713H85.7144V36.7346H89.796V28.5713Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.796 48.9795H85.7144V57.1428H89.796V48.9795Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.796 61.2246H85.7144V65.3062H89.796V61.2246Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.796 73.4692H85.7144V81.6325H89.796V73.4692Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.796 102.041H85.7144V114.286H89.796V102.041Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.796 118.367H85.7144V122.449H89.796V118.367Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.796 126.531H85.7144V134.694H89.796V126.531Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.796 142.857H85.7144V151.02H89.796V142.857Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.796 159.184H85.7144V167.347H89.796V159.184Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.796 175.51H85.7144V183.674H89.796V175.51Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8775 20.4082H89.7959V24.4898H93.8775V20.4082Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8775 36.7349H89.7959V44.8981H93.8775V36.7349Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8775 48.9795H89.7959V53.0611H93.8775V48.9795Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8775 57.1431H89.7959V69.388H93.8775V57.1431Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8775 73.4692H89.7959V77.5509H93.8775V73.4692Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8775 81.6328H89.7959V85.7144H93.8775V81.6328Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8775 93.8774H89.7959V118.367H93.8775V93.8774Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8775 134.694H89.7959V138.775H93.8775V134.694Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8775 151.021H89.7959V155.102H93.8775V151.021Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8775 163.265H89.7959V171.428H93.8775V163.265Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8775 175.51H89.7959V179.592H93.8775V175.51Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9591 24.4897H93.8774V28.5714H97.9591V24.4897Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9591 36.7349H93.8774V40.8165H97.9591V36.7349Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9591 48.9795H93.8774V65.306H97.9591V48.9795Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9591 69.3877H93.8774V81.6326H97.9591V69.3877Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9591 93.8774H93.8774V97.9591H97.9591V93.8774Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9591 102.041H93.8774V110.204H97.9591V102.041Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9591 122.449H93.8774V134.694H97.9591V122.449Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9591 142.857H93.8774V146.939H97.9591V142.857Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9591 151.021H93.8774V167.347H97.9591V151.021Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9591 175.51H93.8774V183.674H97.9591V175.51Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.041 16.3267H97.9592V24.4899H102.041V16.3267Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.041 32.6528H97.9592V36.7345H102.041V32.6528Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.041 40.8164H97.9592V53.0613H102.041V40.8164Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.041 57.1431H97.9592V65.3063H102.041V57.1431Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.041 69.3877H97.9592V77.551H102.041V69.3877Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.041 85.7144H97.9592V97.9593H102.041V85.7144Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.041 114.286H97.9592V118.367H102.041V114.286Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.041 126.531H97.9592V130.612H102.041V126.531Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.041 151.021H97.9592V163.265H102.041V151.021Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.041 171.429H97.9592V179.592H102.041V171.429Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.122 16.3267H102.041V20.4083H106.122V16.3267Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.122 61.2246H102.041V65.3062H106.122V61.2246Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.122 73.4692H102.041V77.5509H106.122V73.4692Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.122 81.6328H102.041V85.7144H106.122V81.6328Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.122 97.959H102.041V102.041H106.122V97.959Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.122 110.204H102.041V114.286H106.122V110.204Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.122 118.367H102.041V155.102H106.122V118.367Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.122 159.184H102.041V171.428H106.122V159.184Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.122 175.51H102.041V179.592H106.122V175.51Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.204 16.3267H106.123V20.4083H110.204V16.3267Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.204 24.4897H106.123V36.7346H110.204V24.4897Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.204 40.8164H106.123V53.0613H110.204V40.8164Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.204 61.2246H106.123V65.3062H110.204V61.2246Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.204 81.6328H106.123V85.7144H110.204V81.6328Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.204 89.7959H106.123V97.9592H110.204V89.7959Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.204 102.041H106.123V118.368H110.204V102.041Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.204 122.449H106.123V130.612H110.204V122.449Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.204 138.775H106.123V146.939H110.204V138.775Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.204 151.021H106.123V155.102H110.204V151.021Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.204 159.184H106.123V163.265H110.204V159.184Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.204 175.51H106.123V179.592H110.204V175.51Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.286 16.3267H110.204V20.4083H114.286V16.3267Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.286 24.4897H110.204V28.5714H114.286V24.4897Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.286 36.7349H110.204V40.8165H114.286V36.7349Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.286 44.8979H110.204V48.9796H114.286V44.8979Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.286 61.2246H110.204V69.3879H114.286V61.2246Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.286 77.5508H110.204V81.6324H114.286V77.5508Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.286 89.7959H110.204V102.041H114.286V89.7959Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.286 110.204H110.204V122.449H114.286V110.204Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.286 130.612H110.204V134.694H114.286V130.612Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.286 138.775H110.204V142.857H114.286V138.775Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.286 146.939H110.204V155.102H114.286V146.939Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.286 159.184H110.204V171.428H114.286V159.184Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.286 175.51H110.204V179.592H114.286V175.51Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.367 20.4082H114.286V24.4898H118.367V20.4082Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.367 32.6528H114.286V44.8977H118.367V32.6528Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.367 53.061H114.286V73.4692H118.367V53.061Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.367 77.5508H114.286V81.6324H118.367V77.5508Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.367 85.7144H114.286V89.796H118.367V85.7144Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.367 93.8774H114.286V102.041H118.367V93.8774Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.367 114.286H114.286V122.449H118.367V114.286Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.367 130.612H114.286V134.694H118.367V130.612Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.367 138.775H114.286V146.939H118.367V138.775Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.367 155.102H114.286V183.673H118.367V155.102Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.449 20.4082H118.367V28.5715H122.449V20.4082Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.449 32.6528H118.367V36.7345H122.449V32.6528Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.449 53.061H118.367V61.2243H122.449V53.061Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.449 65.3062H118.367V81.6327H122.449V65.3062Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.449 110.204H118.367V118.367H122.449V110.204Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.449 134.694H118.367V151.02H122.449V134.694Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.449 163.265H118.367V167.347H122.449V163.265Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.449 175.51H118.367V183.674H122.449V175.51Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.531 20.4082H122.449V24.4898H126.531V20.4082Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.531 36.7349H122.449V48.9798H126.531V36.7349Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.531 53.061H122.449V65.3059H126.531V53.061Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.531 73.4692H122.449V77.5509H126.531V73.4692Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.531 81.6328H122.449V93.8777H126.531V81.6328Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.531 106.123H122.449V110.204H126.531V106.123Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.531 118.367H122.449V138.775H126.531V118.367Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.531 146.939H122.449V155.102H126.531V146.939Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.531 163.265H122.449V171.428H126.531V163.265Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.612 24.4897H126.531V32.653H130.612V24.4897Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.612 44.8979H126.531V48.9796H130.612V44.8979Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.612 53.061H126.531V61.2243H130.612V53.061Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.612 73.4692H126.531V77.5509H130.612V73.4692Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.612 81.6328H126.531V93.8777H130.612V81.6328Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.612 97.959H126.531V126.53H130.612V97.959Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.612 142.857H126.531V146.939H130.612V142.857Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.612 151.021H126.531V159.184H130.612V151.021Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.612 163.265H126.531V179.592H130.612V163.265Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.694 20.4082H130.612V48.9796H134.694V20.4082Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.694 53.061H130.612V57.1427H134.694V53.061Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.694 61.2246H130.612V65.3062H134.694V61.2246Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.694 73.4692H130.612V85.7141H134.694V73.4692Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.694 93.8774H130.612V97.9591H134.694V93.8774Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.694 106.123H130.612V122.449H134.694V106.123Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.694 134.694H130.612V146.939H134.694V134.694Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.694 159.184H130.612V163.265H134.694V159.184Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.694 175.51H130.612V179.592H134.694V175.51Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.775 16.3267H134.694V20.4083H138.775V16.3267Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.775 36.7349H134.694V40.8165H138.775V36.7349Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.775 48.9795H134.694V61.2244H138.775V48.9795Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.775 73.4692H134.694V77.5509H138.775V73.4692Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.775 81.6328H134.694V89.7961H138.775V81.6328Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.775 93.8774H134.694V97.9591H138.775V93.8774Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.775 102.041H134.694V106.123H138.775V102.041Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.775 118.367H134.694V126.53H138.775V118.367Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.775 130.612H134.694V138.776H138.775V130.612Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.775 146.939H134.694V151.021H138.775V146.939Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.775 163.265H134.694V167.347H138.775V163.265Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.775 179.592H134.694V183.673H138.775V179.592Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.857 16.3267H138.775V24.4899H142.857V16.3267Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.857 28.5713H138.775V32.6529H142.857V28.5713Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.857 36.7349H138.775V44.8981H142.857V36.7349Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.857 53.061H138.775V61.2243H142.857V53.061Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.857 65.3062H138.775V77.5511H142.857V65.3062Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.857 85.7144H138.775V89.796H142.857V85.7144Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.857 93.8774H138.775V97.9591H142.857V93.8774Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.857 102.041H138.775V114.286H142.857V102.041Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.857 118.367H138.775V122.449H142.857V118.367Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.857 134.694H138.775V138.775H142.857V134.694Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.857 151.021H138.775V159.184H142.857V151.021Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.857 163.265H138.775V167.347H142.857V163.265Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.939 24.4897H142.857V36.7346H146.939V24.4897Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.939 44.8979H142.857V57.1428H146.939V44.8979Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.939 61.2246H142.857V65.3062H146.939V61.2246Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.939 73.4692H142.857V85.7141H146.939V73.4692Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.939 89.7959H142.857V97.9592H146.939V89.7959Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.939 102.041H142.857V106.123H146.939V102.041Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.939 118.367H142.857V122.449H146.939V118.367Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.939 126.531H142.857V134.694H146.939V126.531Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.939 138.775H142.857V142.857H146.939V138.775Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.939 151.021H142.857V171.429H146.939V151.021Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.939 179.592H142.857V183.673H146.939V179.592Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.02 20.4082H146.939V36.7347H151.02V20.4082Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.02 40.8164H146.939V53.0613H151.02V40.8164Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.02 57.1431H146.939V73.4696H151.02V57.1431Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.02 81.6328H146.939V93.8777H151.02V81.6328Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.02 106.123H146.939V110.204H151.02V106.123Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.02 114.286H146.939V118.367H151.02V114.286Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.02 122.449H146.939V126.531H151.02V122.449Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.02 130.612H146.939V134.694H151.02V130.612Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.02 146.939H146.939V167.347H151.02V146.939Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.102 53.061H151.021V89.7957H155.102V53.061Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.102 110.204H151.021V114.286H155.102V110.204Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.102 118.367H151.021V122.449H155.102V118.367Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.102 138.775H151.021V142.857H155.102V138.775Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.102 146.939H151.021V151.021H155.102V146.939Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.102 163.265H151.021V167.347H155.102V163.265Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.102 171.429H151.021V183.674H155.102V171.429Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.184 16.3267H155.102V44.8981H159.184V16.3267Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.184 48.9795H155.102V53.0611H159.184V48.9795Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.184 65.3062H155.102V69.3878H159.184V65.3062Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.184 85.7144H155.102V89.796H159.184V85.7144Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.184 93.8774H155.102V97.9591H159.184V93.8774Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.184 106.123H155.102V126.531H159.184V106.123Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.184 130.612H155.102V134.694H159.184V130.612Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.184 142.857H155.102V151.02H159.184V142.857Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.184 155.102H155.102V159.184H159.184V155.102Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.184 163.265H155.102V167.347H159.184V163.265Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.184 171.429H155.102V175.51H159.184V171.429Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.265 16.3267H159.184V20.4083H163.265V16.3267Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.265 40.8164H159.184V44.898H163.265V40.8164Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.265 65.3062H159.184V69.3878H163.265V65.3062Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.265 77.5508H159.184V93.8773H163.265V77.5508Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.265 102.041H159.184V106.123H163.265V102.041Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.265 110.204H159.184V114.286H163.265V110.204Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.265 126.531H159.184V142.857H163.265V126.531Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.265 146.939H159.184V151.021H163.265V146.939Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.265 163.265H159.184V175.51H163.265V163.265Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.265 179.592H159.184V183.673H163.265V179.592Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.347 16.3267H163.265V20.4083H167.347V16.3267Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.347 24.4897H163.265V36.7346H167.347V24.4897Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.347 40.8164H163.265V44.898H167.347V40.8164Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.347 48.9795H163.265V57.1428H167.347V48.9795Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.347 61.2246H163.265V65.3062H167.347V61.2246Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.347 69.3877H163.265V81.6326H167.347V69.3877Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.347 85.7144H163.265V102.041H167.347V85.7144Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.347 118.367H163.265V130.612H167.347V118.367Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.347 134.694H163.265V138.775H167.347V134.694Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.347 142.857H163.265V167.347H167.347V142.857Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.347 171.429H163.265V183.674H167.347V171.429Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.429 16.3267H167.347V20.4083H171.429V16.3267Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.429 24.4897H167.347V36.7346H171.429V24.4897Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.429 40.8164H167.347V44.898H171.429V40.8164Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.429 61.2246H167.347V65.3062H171.429V61.2246Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.429 69.3877H167.347V81.6326H171.429V69.3877Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.429 89.7959H167.347V122.449H171.429V89.7959Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.429 126.531H167.347V134.694H171.429V126.531Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.429 142.857H167.347V159.183H171.429V142.857Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.429 167.347H167.347V175.51H171.429V167.347Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.51 16.3267H171.428V20.4083H175.51V16.3267Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.51 24.4897H171.428V36.7346H175.51V24.4897Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.51 40.8164H171.428V44.898H175.51V40.8164Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.51 48.9795H171.428V53.0611H175.51V48.9795Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.51 69.3877H171.428V73.4693H175.51V69.3877Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.51 77.5508H171.428V89.7957H175.51V77.5508Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.51 97.959H171.428V106.122H175.51V97.959Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.51 126.531H171.428V134.694H175.51V126.531Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.51 138.775H171.428V142.857H175.51V138.775Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.51 146.939H171.428V159.184H175.51V146.939Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.51 175.51H171.428V179.592H175.51V175.51Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.592 16.3267H175.51V20.4083H179.592V16.3267Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.592 40.8164H175.51V44.898H179.592V40.8164Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.592 53.061H175.51V57.1427H179.592V53.061Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.592 65.3062H175.51V69.3878H179.592V65.3062Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.592 77.5508H175.51V81.6324H179.592V77.5508Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.592 93.8774H175.51V102.041H179.592V93.8774Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.592 110.204H175.51V114.286H179.592V110.204Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.592 118.367H175.51V122.449H179.592V118.367Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.592 134.694H175.51V138.775H179.592V134.694Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.592 142.857H175.51V146.939H179.592V142.857Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.592 151.021H175.51V155.102H179.592V151.021Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.592 171.429H175.51V175.51H179.592V171.429Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.673 16.3267H179.592V44.8981H183.673V16.3267Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.673 48.9795H179.592V53.0611H183.673V48.9795Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.673 61.2246H179.592V73.4695H183.673V61.2246Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.673 85.7144H179.592V97.9593H183.673V85.7144Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.673 110.204H179.592V114.286H183.673V110.204Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.673 118.367H179.592V122.449H183.673V118.367Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.673 126.531H179.592V130.612H183.673V126.531Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.673 134.694H179.592V142.857H183.673V134.694Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.673 146.939H179.592V151.021H183.673V146.939Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.673 159.184H179.592V163.265H183.673V159.184Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.673 167.347H179.592V171.429H183.673V167.347Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.673 175.51H179.592V179.592H183.673V175.51Z",
    fill: "#454545"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 199,
    height: 199,
    rx: 7.5,
    stroke: "#CCCBCE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_135_3233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_135_3233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrApp);
export default __webpack_public_path__ + "static/media/QR_App.ef8397c33f7f744df29634e61d4d6b96.svg";
export { ForwardRef as ReactComponent };